   
    
    import MatriculaService from   "@/service/v1/sigap/MatriculaService"  
    import { Options, Vue  } from "vue-class-component";    
    import   SiteUtils   from '@/assets/ts/aplicacao/site';  
    import Editar from   "./_Editar.vue"    
    import Certificado from   "./_Certificado.vue"   
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 
    import ApiService from "@/service/ApiService"; 
    import Pdf from "./faltas/_Pdf.vue";

    @Options({
        name: "MatriculaShow",
        components: {   Certificado,  Editar, Pdf  },   
    }) 
    export default class MatriculaShow extends Vue {
        
        @authStore.Getter
		public perfis!: any  

        @authStore.Getter
		public token!: any 
  
        public service = new MatriculaService();
        public model: any = null ;
        public processando = false ;

        public isProdrucao =   ApiService.isProducao();
         
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
        }
 
        get hasPermissaoEditar( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }

        get hasAdmin( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin  ] ,  this.perfis); 
        }

        public formatCPF( cpf ): string {
            return SiteUtils.formatCPF( cpf );
        }

        created(){
            this.buscaMatricula(); 
        }

        public statusAlterado(dados){ 
            this.buscaMatricula() ;
        }

        public buscaMatricula(){   
            this.processando = true ; 
            this.service.getModel( this.$route.params.id  ) 
            .then(response => {   
                this.model =  JSON.parse(JSON.stringify( response ));  
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 
 
        public gerarBoletimExcell() {  
            window.open( this.service.getApiUrl() + '/' + this.$route.params.id + '/Boletim/Excel' + '?token=' +  this.token );
		}
         
        public gerarHistoricoExcell() {  
            window.open( this.service.getApiUrl() + '/' + this.$route.params.id + '/Historico/Excel' + '?token=' +  this.token );
		}
 
    } 
